import React from 'react'
import { Row, styleguide } from 'styleguide'
import scoopsA from './hero-question-a.svg'
import scoopsB from './hero-question-b.svg'
import * as Illustrations from '../../Illustrations'
import { css } from 'react-emotion'

export default function({ style }) {
  return (
    <Row
      css={`
        width: 100%;
        min-height: 200px;
        transform: scale3d(0.6, 0.6, 1) translateX(88px) translateY(-10px);
        transform-origin: center;
        ${styleguide.desktop(
          css`
            margin-left: 80px;
            transform: none;
          `
        )};
      `}>
      <div
        css={`
          width: 400px;
          position: absolute;
          right: 80px;
          top: 25px;
          background-color: ${styleguide.colors.background};
          z-index: 1;
          border-radius: ${styleguide.radii.outer};
          overflow: hidden;
          ${styleguide.shadows.button};
        `}>
        <img
          src={scoopsA}
          alt="faded scoops survey"
          css={`
            opacity: 0.3;

            width: 100%;
          `}
        />
      </div>
      <div
        css={`
          width: 400px;
          position: absolute;
          z-index: 2;
          right: 0px;
          top: 125px;
          border-radius: ${styleguide.radii.outer};
          ${styleguide.shadows.button};
          overflow: hidden;
          background-color: ${styleguide.colors.background};
        `}>
        <img
          src={scoopsB}
          alt="scoops survey"
          css={`
            width: 100%;
          `}
        />
      </div>

      <div
        css={`
          position: absolute;
          width: 100%;
          top: -25px;
          height: 100%;
        `}>
        <Illustrations.Stripes
          color="primary"
          css={`
            position: absolute;
            right: -120px;
            top: -80px;
            width: 680px;
            height: 680px;
            z-index: 0;
            transform: rotate(-15deg);
          `}
        />
        <Illustrations.ChevronCircle
          color="illustrationLightBlue"
          css={`
            position: absolute;
            right: -140px;
            top: -30px;
            width: 400px;
            height: 400px;
            z-index: 0;
          `}
        />
        <Illustrations.PokadotCircle
          color="secondary"
          css={`
            position: absolute;
            right: 420px;
            top: 210px;
            width: 100px;
            height: 100px;
            z-index: 3;
          `}
        />
        <Illustrations.PokadotCircle
          color="primary"
          css={`
            position: absolute;
            right: 360px;
            top: 260px;
            width: 200px;
            height: 200px;
            z-index: 0;
          `}
        />
      </div>
    </Row>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sections/Hero/HeroIllustration.jsx